export const manageTokensRouteConfig = {
  url: '/manage-tokens',
  dataShippingUrl: '/data-shipping',
};
